module.exports = __webpack_public_path__ + "img/document.1e48f1c5.png";